import React from "react";
import AudioClipLibrary from "@/components/audio/AudioClipLibrary";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export default function AudioClipsTab() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Audio Clips</CardTitle>
        <CardDescription>Recordings for call flows and hold music</CardDescription>
      </CardHeader>
      <CardContent>
        <AudioClipLibrary />
      </CardContent>
    </Card>
  );
}
